module.exports = __webpack_public_path__ + "img/ic_check.0f7bea8b.svg";